<template>
  <Modal
    ref="modal"
    class="CreateGroupModal"
    :heading="messages.group.createGroup"
    :size="isExtraSmallPixel ? 'extraSmall' : 'small'"
    @closeModal="onClickModalClose"
  >
    <div class="CreateGroupModal__modalInner">
      <Icon class="CreateGroupModal__icon" iconName="Exception"></Icon>
      <!-- safe usage of v-html: content is fully static and developer-controlled -->
      <p
        v-if="isError"
        class="CreateGroupModal__modalText"
        v-html="messages.group.fail.createGroup"
      ></p>
      <p
        v-else
        class="CreateGroupModal__modalText"
        v-html="messages.group.fail.groupLimitReached"
      ></p>
      <div class="CreateGroupModal__modalButton">
        <Button
          tag="button"
          dynamics="secondary"
          :label="messages.common.close"
          @click="onClickModalClose"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
export default {
  name: 'CreateGroupModal',
};
</script>

<script lang="ts" setup>
import Button from '@spectee/components/Atoms/Button/index.vue';
import Modal from '@spectee/components/Organisms/Modal/index.vue';
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
import { useWindowWidth } from '@spectee/composables/useWindowWidth';
import messages from '../../../../messages.json';

type Props = {
  isError: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  isError: false,
});

const { isExtraSmallPixel } = useWindowWidth();

const emit = defineEmits<{
  (e: 'onClickModalClose'): void;
}>();

const onClickModalClose = () => {
  emit('onClickModalClose');
  return;
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;
.CreateGroupModal {
  padding: $service-unit * 4 $service-unit * 4 $service-unit * 6;

  &__modalButton {
    margin-top: $service-unit * 6;
    text-align: center;
  }

  &__modalInner {
    text-align: center;
  }

  &__modalText {
    margin-top: $service-unit * 6;
    font-size: $service-font-size-p;
    line-height: $service-line-height-mf;
  }

  &__icon {
    width: $service-unit * 10;
    margin: $service-unit * 4 $service-unit * 38 0 $service-unit * 38;
    fill: #c33b2e;
  }

  @media (max-width: 424px) {
    &__icon {
      margin-left: $service-unit * 28;
    }
  }
}
</style>
